/* import __COLOCATED_TEMPLATE__ from './button-editor.hbs.js'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { next } from '@ember/runloop';
import { cleanUrl } from '@intercom/embercom-prosemirror-composer/lib/helpers/clean-url';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { ref } from 'ember-ref-bucket';
import { INLINE_CONTROL_ALIGNMENT } from '@intercom/embercom-prosemirror-composer/lib/config/composer-config';
import { ColorPickerType } from '../utils/constants';
let ButtonEditor = (_dec = ref('textInputElement'), _dec2 = ref('linkUrlInputElement'), (_class = class ButtonEditor extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isEditing", _descriptor, this);
    _initializerDefineProperty(this, "textInputElement", _descriptor2, this);
    _initializerDefineProperty(this, "linkUrlInputElement", _descriptor3, this);
    _defineProperty(this, "colorPickerType", ColorPickerType.BUTTON);
  }
  get attributeInfoResolver() {
    return this.args.composer.config.templating?.resolver;
  }
  get text() {
    return this.node.attrs.text;
  }
  get linkUrl() {
    return this.node.attrs.linkUrl;
  }
  get composer() {
    return this.args.composer;
  }
  get node() {
    let selection = this.composer.state.prosemirrorState.selection;
    return selection?.node;
  }
  get isVisible() {
    return this.composer.state.prosemirrorState.schema.nodes.button && this.node?.type === this.composer.state.prosemirrorState.schema.nodes.button && !this.composer.config.inserters?.hideButtonEditor;
  }
  get showAlignment() {
    return !this.composer.config.hideFromBlockFormatter.includes(INLINE_CONTROL_ALIGNMENT);
  }
  startEditing() {
    this.isEditing = true;
  }
  toggleCenter() {
    this.composer.commands.toggleCenter();
    this.composer.commands.focus();
  }
  switchToEditingModeIfEmpty() {
    if (isEmpty(this.linkUrl) || isEmpty(this.text)) {
      this.isEditing = true;
    } else {
      this.isEditing = false;
    }
  }
  focus(element) {
    next(this, () => {
      element.focus();
    });
  }
  keyUp(e) {
    if (e.key === 'Enter') {
      this.isEditing = false;
    }
  }
  update() {
    if (this.textInputElement && this.linkUrlInputElement) {
      this.composer.commands.updateSelectedNode({
        text: this.textInputElement.value,
        linkUrl: cleanUrl(this.linkUrlInputElement.value)
      });
    }
  }
  onInsertText(attributeTemplate, attributeTemplateStartPosition = 0, attributeTemplateEndPosition = 0) {
    if (this.textInputElement) {
      this.setSelectionRange(this.textInputElement, attributeTemplate, attributeTemplateStartPosition, attributeTemplateEndPosition);
    }
  }
  onInsertLink(attributeTemplate, attributeTemplateStartPosition = 0, attributeTemplateEndPosition = 0) {
    if (this.linkUrlInputElement) {
      this.setSelectionRange(this.linkUrlInputElement, attributeTemplate, attributeTemplateStartPosition, attributeTemplateEndPosition);
    }
  }
  setSelectionRange(inputElement, attributeTemplate, attributeTemplateStartPosition, attributeTemplateEndPosition) {
    let targetStartPosition = inputElement.value.length + attributeTemplateStartPosition;
    let targetEndPosition = inputElement.value.length + attributeTemplateEndPosition;
    inputElement.value += attributeTemplate;
    inputElement.focus();
    inputElement.setSelectionRange(targetStartPosition, targetEndPosition);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isEditing", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "textInputElement", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "linkUrlInputElement", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "startEditing", [action], Object.getOwnPropertyDescriptor(_class.prototype, "startEditing"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCenter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCenter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "switchToEditingModeIfEmpty", [action], Object.getOwnPropertyDescriptor(_class.prototype, "switchToEditingModeIfEmpty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keyUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "keyUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "update", [action], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInsertText", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsertText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInsertLink", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsertLink"), _class.prototype)), _class));
export { ButtonEditor as default };